import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/components/ThemeProvider";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppLayout } from "@/components/layout/AppLayout";
import Login from "@/pages/Login";
import VerifyOtp from "@/pages/VerifyOtp";
import Dashboard from "@/pages/Dashboard";
import Clinics from "@/pages/Clinics";
import ClinicDetail from "@/pages/ClinicDetail";
import Approvals from "@/pages/Approvals";
import Revenue from "@/pages/Revenue";
import Subscribers from "@/pages/Subscribers";
import DemoRequests from "@/pages/DemoRequests";
import CustomMessaging from "@/pages/CustomMessaging";

function PublicOnly({ children }) {
  const { isAuthenticated, ready } = useAuth();
  if (!ready) return null;
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : children;
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
        <Route path="/verify-otp" element={<PublicOnly><VerifyOtp /></PublicOnly>} />
        <Route element={<AppLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/clinics" element={<Clinics />} />
          <Route path="/approvals" element={<Approvals />} />
          <Route path="/clinics/:id" element={<ClinicDetail />} />
          <Route path="/revenue" element={<Revenue />} />
          <Route path="/subscribers" element={<Subscribers />} />
          <Route path="/demo-requests" element={<DemoRequests />} />
          <Route path="/custom-messaging" element={<CustomMessaging />} />
        </Route>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AnimatedRoutes />
          <Toaster position="top-right" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
